import styles from './Select.module.scss'
import { v4 as uuidv4 } from 'uuid'

import { IInputStatus } from '../../../interface/progress.interface'
import { IChangeValue } from '../../../interface/steps.interface'
import useSelect from './hooks/useSelect'

interface Props {
  value: string
  name: string
  handleChange: IChangeValue
  status: IInputStatus
  settings: any //ISelectInputSettings
}

const Select = ({ value, name, status, handleChange, settings }: Props) => {
  const { label, placeholder, emptyErrorText, options } = settings
  const id = uuidv4()

  console.log(name, status)
  const {
    currentLabel,
    wrapperRef,
    selectRef,
    optionsWrapperRef,
    optionsArrRef,
    optionsRef,
    hasError,
    handleClick,
    handleOptionClick,
  } = useSelect({ name, value, styles, options, status, handler: handleChange })

  return (
    // <div>
      <div className={styles.wrapper}>
        <div className={styles.content} ref={wrapperRef} onClick={handleClick}>
          <div className={styles.pseudoSelect} id={id} ref={selectRef}>
            {currentLabel}
          </div>
          <label className={styles.label} htmlFor={id}>
            {placeholder}
          </label>
          <div className={styles.pseudoOptionsWrapper} ref={optionsWrapperRef}>
            <div className={styles.pseudoOptionsContent}>
              <ul className={styles.pseudoOptions} ref={optionsRef}>
                {options.map((option: any, index: number) => {
                  const optionId = uuidv4()
                  return (
                    <li
                      className={styles.pseudoOption}
                      key={optionId}
                      onClick={() => handleOptionClick(String(option.value))}
                      ref={(el: HTMLLIElement) =>
                        (optionsArrRef.current[index] = el)
                      }
                    >
                      {option.label}
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
        {hasError && <div className={styles.error}>{emptyErrorText}</div>}
      </div>
    // </div>

  )
}

export default Select
